
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`New Location`}</h3>
    <p>{`We've moved! In order to make our documentation as accessible as possible, we've migrated our entire process over to GitHub. Our documentation can now be found at pxblue.github.io.`}</p>
    <h3>{`Shifting Left on Test`}</h3>
    <p>{`In an effort to make our packages and examples more stable, we've integrated automated testing (with CircleCI) into all of our code, including our NPM packages and code examples. You can see the current status of all of these materials on the `}<a parentName="p" {...{
        "href": "/resources"
      }}>{`Resources`}</a>{` page.`}</p>
    <h3>{`Updated Code Examples`}</h3>
    <p>{`We've added code examples for `}<a parentName="p" {...{
        "href": "/patterns/appbar"
      }}>{`App Bars`}</a>{`, `}<a parentName="p" {...{
        "href": "/patterns/overlay"
      }}>{`Bottom Sheets`}</a>{`, and `}<a parentName="p" {...{
        "href": "/patterns/steppers"
      }}>{`Steppers`}</a>{`, with more coming soon.`}</p>
    <h3>{`Miscellaneous`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes, including improving the consistency of PX Blue themes between Angular and React`}</li>
      <li parentName="ul">{`New icons added to `}<a parentName="li" {...{
          "href": "/style/iconography"
        }}>{`PX Blue icons`}</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;